import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { ExternalRequisitionReportFilter } from '../../models/requisitions/interfaces/external-requisition';

@Injectable({
  providedIn: 'root',
})
export class ReportsProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/reports';
  getExternalRequisitionReport(filter: ExternalRequisitionReportFilter) {
    return this.httpClient.post(`${this.baseUrl}/excel/requisitions/external-requisition-report`, filter, {
      responseType: 'blob',
    });
  }
}
